import { render } from "./ConectadosDetalleModal.vue?vue&type=template&id=61ba53cc"
import script from "./ConectadosDetalleModal.vue?vue&type=script&lang=js"
export * from "./ConectadosDetalleModal.vue?vue&type=script&lang=js"

import "./ConectadosDetalleModal.vue?vue&type=style&index=0&id=61ba53cc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__